import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
import {
  SecondarySelectCardButton,
  SecondarySelectCardButtonProps,
} from '../../button';

export type SecondarySelectCardsProps = {
  initialValue?: string;
  onSelect: (value: string) => void;
  options: SecondarySelectCardButtonProps[];
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Card = styled(SecondarySelectCardButton)`
  margin: 0 ${theme.spacings[4].rem} ${theme.spacings[4].rem} 0;
`;

export const SecondarySelectCards: React.FC<SecondarySelectCardsProps> = ({
  initialValue,
  onSelect,
  options,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    options.find((opt) => opt.value === initialValue)?.value
  );

  const handleSelect = (value: string) => {
    onSelect(value);
    setSelectedOption(value);
  };

  return (
    <Wrapper>
      {options.map((opt) => (
        <Card
          children={opt.children}
          key={opt.value}
          onClick={handleSelect}
          selected={opt.value === selectedOption}
          value={opt.value}
        />
      ))}
    </Wrapper>
  );
};
